import React from 'react';

export default function ImageDuoConfig({ data, onChange }) {
  const update = (field, value) => onChange({ ...data, [field]: value });

  return (
    <>
      <div className="adminblog-field">
        <label>Image 1 URL</label>
        <input type="text" value={data.image1 || ''} onChange={(e) => update('image1', e.target.value)} placeholder="First image URL" />
        {data.image1 && <img src={data.image1} alt="Preview 1" style={{ width: '100%', borderRadius: 6, marginTop: 8, height: 100, objectFit: 'cover' }} />}
      </div>
      <div className="adminblog-field">
        <label>Caption 1 (optional)</label>
        <input type="text" value={data.caption1 || ''} onChange={(e) => update('caption1', e.target.value)} placeholder="Caption for image 1" />
      </div>
      <div className="adminblog-field">
        <label>Image 2 URL</label>
        <input type="text" value={data.image2 || ''} onChange={(e) => update('image2', e.target.value)} placeholder="Second image URL" />
        {data.image2 && <img src={data.image2} alt="Preview 2" style={{ width: '100%', borderRadius: 6, marginTop: 8, height: 100, objectFit: 'cover' }} />}
      </div>
      <div className="adminblog-field">
        <label>Caption 2 (optional)</label>
        <input type="text" value={data.caption2 || ''} onChange={(e) => update('caption2', e.target.value)} placeholder="Caption for image 2" />
      </div>
      <div className="adminblog-field">
        <label>Aspect Ratio</label>
        <select value={data.ratio || 'portrait'} onChange={(e) => update('ratio', e.target.value)}>
          <option value="square">Square (1:1)</option>
          <option value="portrait">Portrait (3:4)</option>
          <option value="landscape">Landscape (16:9)</option>
        </select>
      </div>
    </>
  );
}
